import React, { useState } from 'react';
import PageBanner from '../components/PageBanner';

const PERKS = [
  { title: 'مرونة في العمل', desc: 'نظام عمل هجين وساعات مرنة تناسب حياتك.' },
  { title: 'تأمين صحي شامل', desc: 'تغطية صحية لك ولأسرتك من أول يوم عمل.' },
  { title: 'فرص تطور حقيقية', desc: 'برامج تدريب داخلية ودعم للتعلم المستمر.' },
  { title: 'خصومات المتجر', desc: 'خصم خاص للموظفين على كل منتجات MEME STORE.' },
];

const OPEN_ROLES = [
  { title: 'مسؤول تسويق رقمي', dept: 'التسويق', location: 'الرياض · دوام كامل' },
  { title: 'مطور واجهات أمامية', dept: 'التقنية', location: 'عن بعد · دوام كامل' },
  { title: 'أخصائي خدمة عملاء', dept: 'خدمة العملاء', location: 'الرياض · دوام كامل' },
  { title: 'مصمم UI/UX', dept: 'المنتج', location: 'عن بعد · دوام جزئي' },
];

const Careers = () => {
  const [activeDept, setActiveDept] = useState('الكل');
  const depts = ['الكل', ...new Set(OPEN_ROLES.map((r) => r.dept))];

  const filteredRoles =
    activeDept === 'الكل' ? OPEN_ROLES : OPEN_ROLES.filter((r) => r.dept === activeDept);

  return (
    <div dir="rtl">
      <PageBanner
        eyebrow="انضم لفريقنا"
        title="الوظائف في MEME STORE"
        subtitle="بنبني تجربة تسوق مختلفة، ومحتاجين ناس شغوفة تبنيها معانا."
      />

      <div className="container mx-auto px-4 py-14">

        {/* المميزات */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {PERKS.map((perk) => (
            <div key={perk.title} className="bg-[#F6F5F2] rounded-2xl p-6">
              <h3 className="font-bold text-[#1B1B1F] mb-2">{perk.title}</h3>
              <p className="text-sm text-gray-600 leading-6">{perk.desc}</p>
            </div>
          ))}
        </div>

        {/* الوظائف المتاحة */}
        <div>
          <h2
            className="text-2xl font-bold text-[#1B1B1F] mb-6"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            الوظائف المتاحة حالياً
          </h2>

          <div className="flex flex-wrap gap-2 mb-6">
            {depts.map((dept) => (
              <button
                key={dept}
                type="button"
                onClick={() => setActiveDept(dept)}
                className={`px-4 py-2 rounded-full text-sm font-bold transition-colors ${
                  activeDept === dept
                    ? 'bg-[#1B1B1F] text-white'
                    : 'bg-[#F6F5F2] text-[#1B1B1F] hover:bg-[#F2B705]/30'
                }`}
              >
                {dept}
              </button>
            ))}
          </div>

          <div className="space-y-4">
            {filteredRoles.map((role) => (
              <div
                key={role.title}
                className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white border border-gray-100 rounded-2xl p-6 shadow-[0_2px_10px_rgba(27,27,31,0.05)] hover:shadow-lg transition-shadow"
              >
                <div>
                  <h3 className="font-bold text-[#1B1B1F] text-lg">{role.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">
                    {role.dept} · {role.location}
                  </p>
                </div>

                <a
                  href="mailto:careers@memestore.sa"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-[#F2B705] text-[#1B1B1F] font-bold hover:bg-[#1B1B1F] hover:text-white transition-colors shrink-0"
                >
                  قدّم الآن
                </a>
              </div>
            ))}

            {filteredRoles.length === 0 && (
              <p className="text-gray-500 text-center py-10">لا توجد وظائف متاحة في هذا القسم حالياً.</p>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Careers;
